import { render, staticRenderFns } from "./VideoCall.vue?vue&type=template&id=1fa3e7f4&scoped=true&lang=pug&"
import script from "./VideoCall.vue?vue&type=script&lang=js&"
export * from "./VideoCall.vue?vue&type=script&lang=js&"
import style0 from "./VideoCall.vue?vue&type=style&index=0&id=1fa3e7f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa3e7f4",
  null
  
)

export default component.exports